import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as hookActions from 'checkout/actions/hooks';
import { getOrderTotal } from '../../selectors/cart';
import { inLastStep } from '../../selectors/ui';
import { GoogleAnalytics4 } from './GoogleAnalytics4';
import { toDecimals } from "../../helpers/currency";

class GoogleConversion extends GoogleAnalytics4 {
  reportEvent = (event, args) => {
    // ID and Label got unified into `id` on AnalyticsContainer.js:unifyAnalytics
    this.props.reportEvent(`${this.props.config.id}`)('event', event, {
      ...args,
      send_to: `${this.props.config.id}`,
    });
  };

  constructor(props) {
    super(props);

    if (props.config?.id) {
      // subscribe to hooks
      this.props.addReservationCompleteHook(this.onReservationComplete);
    }
  }

  render() {
    return null;
  }

  onReservationComplete = () => {
    const reservationSessionKey = `GoogleConversion_onReservationComplete_${this.props.confirmationNumber}`;
    const sent = sessionStorage.getItem(reservationSessionKey);
    if (!sent) {
      // purchase event
      this.reportWholeReservationEvent('conversion', {
        transaction_id: this.props.confirmationNumber,
        revenue: toDecimals({amount: this.props.orderTotal, currency: this.props.currency}),
        insurance: this.props.hasInsurance ? "On" : "Off",
      });

      sessionStorage.setItem(reservationSessionKey, '1');
    }
  };
}

const mapStateToProps = (state) => {
  return {
    payments: state.payment.payments,
    confirmationNumber: state.reservation.confirmation_number,
    inLastStep: inLastStep(state),
    currency: state.reservation.currency || 'USD',
    orderTotal: getOrderTotal(state)?.amount ?? 0,
    tickets: state.tickets.tickets,
    productSales: state.productSales.products,
    bundleSales: state.bundleSales.bundles,
    hasInsurance: !!state.reservation.insuranceProvider,
  };
};

const mapDispatchToProps = (dispatch) => {
  const actions = {};
  Object.keys(hookActions).forEach((hookActionName) => {
    actions[hookActionName] = hookActions[hookActionName];
  });
  return bindActionCreators(actions, dispatch);
};

GoogleConversion.propTypes = {
  config: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(GoogleConversion);
